import { css } from "@emotion/react";
import { FC } from "react";

import { Avatar } from "@livechat/design-system-react-components";

interface IProps {
  avatarUrl: string;
  name: string;
  email: string;
  removed?: boolean;
  onClick?(): void;
}

export const AgentCard: FC<IProps> = ({ avatarUrl, name, email, removed }) => {
  return (
    <div css={container}>
      <div css={[avatar, removed && removedAvatar]}>
        <Avatar
          type={avatarUrl ? "image" : "text"}
          src={avatarUrl ? avatarUrl : undefined}
          text={name ?? email}
          size="small"
        />
      </div>
      <div css={contacts}>
        {!removed ? <span css={name}>{name}</span> : <div css={[name, removed]}>Agent Removed</div>}
        <small css={email}>{email}</small>
      </div>
    </div>
  );
};

const container = css`
  display: flex;
  flex-direction: row;
`;

const avatar = css`
  flex-shrink: 0;
`;

const contacts = css`
  display: flex;
  flex-direction: column;
  margin-left: 6px;
  overflow: hidden;
`;

const removedAvatar = css`
  opacity: 0.3;
`;
